// A vulture, modelled facing +X: a dark hunched body, broad ragged wings, a
// bare pinkish head and a hooked beak. Circles the desert. Ported 1:1 from
// age-of-mcp's classic vulture.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#3a3026",
      position: [0, 0.03, 0], scale: [1.5, 1.1, 0.9] },             // body
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#c08878",
      position: [0.06, 0.052, 0] },                                  // bare head
    { geometry: new THREE.ConeGeometry(0.011, 0.026, 4), color: "#3a322a",
      position: [0.086, 0.05, 0], rotation: [0, 0, -1.2] },          // hooked beak
    { geometry: new THREE.ConeGeometry(0.028, 0.16, 3), color: "#2e2620",
      position: [-0.01, 0.03, 0.09], rotation: [Math.PI / 2, 0, 0], scale: [1, 1, 0.28] },
    { geometry: new THREE.ConeGeometry(0.028, 0.16, 3), color: "#2e2620",
      position: [-0.01, 0.03, -0.09], rotation: [-Math.PI / 2, 0, 0], scale: [1, 1, 0.28] },
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#4a4034",
      position: [0.03, 0.06, 0], scale: [1, 0.6, 1.4] },             // ruff
  ];
}

export const vulture = defineModel({
  id: "vulture",
  batchId: "standard",
  name: "Vulture",
  tags: ["creature","vulture","low-poly","age-of-mcp","classic"],
  summary: "Low-poly vulture.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.13,
  parts: () => partsFor(),
  animations: [],
});
